// Angular
import { Inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { UserTypeEnum } from "@cai-services";
import { RegisterService } from "../_services/register.service";
import { SessionService } from "../_services/session.service";
// Auth reducers and selectors
import { APP_PROPS } from "../../cai-common.module";
import { ApplicationProperties } from "../_base/layout/models/app-properties.model";
import { ForwarderGuard } from "./forwarder.guard";

@Injectable()
export class TestAccountGuard extends ForwarderGuard {
  private guardRouter: Router;

  constructor (
    @Inject(APP_PROPS)
    appProperties: ApplicationProperties,
    router: Router,
    sessionService: SessionService,
    registerService: RegisterService
  ) {
    super(appProperties, router, sessionService, registerService);
    this.guardRouter = router;
  }

  async canActivate (): Promise<boolean> {
    let user = this.sessionService.getCurrentUser();
    if (!user) {
      user = await this.registerService.getUser();
      this.sessionService.setCurrentUser(user);
    }

    if (
      user.company?.providers.length > 0 &&
      user?.company?.providers[0] !== "DHL"
    ) {
      const userMenu = this.appProperties.menu.find(
        (config) => config.userType === UserTypeEnum.FORWARDER
      );
      if (userMenu) {
        this.guardRouter.navigate([userMenu.defaultPage]);
      }
      return false;
    }
    return true;
  }
}
